import React from "react";

import { func, object } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";

import { useSelector } from "react-redux";

import { csvClientIsLoadingSelector } from "../../selectors";
import { ButtonWithSpinner } from "../../../../components/common";
import { CLIENT_UPLOAD_SUPPORTED_FORMATS } from "../../constants/formValidations";
import UploadFileScoreCards from "../../../../components/formik/uploadScoreCard/UploadFileScoreCards";

const UploadCsvClientsForm = ({
  handleUploadCsvClientsSubmit,
  initialUploadCsvClientsValues,
  disabled,
}) => {
  const isLoading = useSelector(csvClientIsLoadingSelector);

  return (
    <Formik
      onSubmit={handleUploadCsvClientsSubmit}
      initialValues={initialUploadCsvClientsValues}
      enableReinitialize
    >
      <Form className="upload-csv-clients-form" name="uploadCsvClientsForm">
        <div className="upload-score-card-main-container">
          <div>Upload .CSV file with clients</div>
          <Row>
            <Col className="limited-input-characters" lg={12}>
              <Field
                name="csvFile"
                component={UploadFileScoreCards}
                key={initialUploadCsvClientsValues.randomNum}
                accept={CLIENT_UPLOAD_SUPPORTED_FORMATS}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ButtonWithSpinner
                className="upload-score-card-button"
                text="Upload"
                outline
                type="submit"
                loading={isLoading}
                disabled={disabled}
              />
            </Col>
          </Row>
        </div>
      </Form>
    </Formik>
  );
};

UploadCsvClientsForm.propTypes = {
  handleUploadCsvClientsSubmit: func.isRequired,
  initialUploadCsvClientsValues: object.isRequired,
};

export default UploadCsvClientsForm;



// WEBPACK FOOTER //
// ./src/features/score-card/components/upload-csv-clients-form/UploadCsvClientsForm.jsx